import React from 'react';
import { getNotificacion, marcarNotificacionLeida } from "./NotificacionService";

class ModalNotificacion extends React.Component {
    constructor(props) {
        super(props);
        this.dialogRef = React.createRef();
        this.state = {
            notificacion: null,
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        if (this.props.open) {
            this.abrirModal();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.open !== prevProps.open) {
            if (this.props.open) {
                this.abrirModal();
                this.cargarNotificacion();
            } else {
                this.cerrarModalConAnimacion();
            }
        }

        if (this.props.idNotificacion !== prevProps.idNotificacion && this.props.open) {
            this.cargarNotificacion();
        }
    }

    abrirModal = () => {
        if (this.dialogRef.current && !this.dialogRef.current.open) {
            this.dialogRef.current.showModal();
        }
    }

    cerrarModalConAnimacion = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.style.scale = '0';
            setTimeout(() => {
                if (this.dialogRef.current && this.dialogRef.current.open) {
                    this.dialogRef.current.close();
                }
            }, 300);
        }
    }

    manejarCerrar = () => {
        this.cerrarModalConAnimacion();
        setTimeout(() => {
            this.setState({ notificacion: null, error: null });
            this.props.onClose();
        }, 300);
    }

    cargarNotificacion = async () => {
        if (!this.props.idNotificacion) return;

        this.setState({ loading: true, error: null });

        try {
            const data = await getNotificacion(this.props.idNotificacion);
            this.setState({ notificacion: data.datos });

            if (this.props.username) {
                await marcarNotificacionLeida(this.props.idNotificacion, this.props.username);
            }
        } catch (e) {
            console.error("Error cargando notificación:", e);
            this.setState({ error: "Error al cargar la notificación" });
        } finally {
            this.setState({ loading: false });
        }
    }

    getTipoBadgeClass = (codigo) => {
        switch (codigo) {
            case "03": return "label__error";
            case "01": return "label__warning";
            default:   return "label__info";
        }
    }

    getEstadoBadgeClass = (codigo) => {
        switch (codigo) {
            case "02": return "label__success";
            case "03": return "label__error";
            default:   return "label__default";
        }
    }

    renderReceptores = (receptores) => {
        if (!receptores || receptores.length === 0) return null;

        return (
            <div className="component-table">
                <h4 className="table-title">Receptores</h4>
                <div className="responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Cédula</th>
                                <th>Estado</th>
                                <th>Fecha de lectura</th>
                            </tr>
                        </thead>
                        <tbody>
                            {receptores.map((r, i) => (
                                <tr key={i}>
                                    <td>{r.nombre}</td>
                                    <td>{r.cedula}</td>
                                    <td>
                                        <span className={r.leida ? "label__success" : "label__info"}>
                                            {r.leida ? "Leída" : "Sin leer"}
                                        </span>
                                    </td>
                                    <td>{r.fechaLectura || "—"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        const { open } = this.props;
        const { notificacion, loading, error } = this.state;

        if (!open) return null;

        return (
            <div className="component-modal">
                <dialog
                    className="modal modal-action"
                    id="modal-notificacion"
                    ref={this.dialogRef}
                    onClose={this.manejarCerrar}
                    style={{ width: "56rem", maxWidth: "95vw" }}
                >
                    <div className="modal-content">

                        <div className="modal-head" style={{ paddingBottom: "0" }}>
                            <div className="modal-caption">
                                <h3 className="modal-title">Detalle de notificación</h3>
                            </div>
                        </div>

                        <div className="modal-body">
                            {loading ? (
                                <p className="msg">Cargando...</p>
                            ) : error ? (
                                <p className="msg">{error}</p>
                            ) : notificacion ? (
                                <>
                                    <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                                        {notificacion.tipo && (
                                            <span className={this.getTipoBadgeClass(notificacion.tipo.codigo)}>
                                                {notificacion.tipo.descripcion}
                                            </span>
                                        )}
                                        {notificacion.estado && (
                                            <span className={this.getEstadoBadgeClass(notificacion.estado.codigo)}>
                                                {notificacion.estado.descripcion}
                                            </span>
                                        )}
                                    </div>

                                    <h3 className="title">{notificacion.titulo}</h3>

                                    <p className="msg">{notificacion.resumen}</p>

                                    {notificacion.desarrollo && (
                                        <p className="msg">{notificacion.desarrollo}</p>
                                    )}

                                    <div className="card">
                                        {notificacion.nombreCreador && (
                                            <p className="info-data-txt txt-detail">
                                                <strong>Creador:</strong> {notificacion.nombreCreador}
                                            </p>
                                        )}
                                        {notificacion.fechaEnvio && (
                                            <p className="info-data-txt txt-detail">
                                                <strong>Fecha de envío:</strong> {notificacion.fechaEnvio}
                                            </p>
                                        )}
                                        {notificacion.fechaCaducidad && (
                                            <p className="info-data-txt txt-detail">
                                                <strong>Expira:</strong> {notificacion.fechaCaducidad}
                                            </p>
                                        )}
                                        {notificacion.duracionDias != null && (
                                            <p className="info-data-txt txt-detail">
                                                <strong>Duración:</strong> {notificacion.duracionDias} días
                                            </p>
                                        )}
                                    </div>

                                    {this.props.mostrarReceptores && this.renderReceptores(notificacion.listaUsuariosReceptores)}
                                </>
                            ) : (
                                <p className="msg">No se pudo cargar la notificación.</p>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                onClick={this.manejarCerrar}
                                className="btn-medium btn-primary"
                                type="button"
                            >
                                Cerrar
                            </button>
                        </div>

                    </div>
                </dialog>
            </div>
        );
    }
}

export default ModalNotificacion;
